<template>
  <el-tabs v-model="activeName"
           type="card">
    <el-tab-pane label="主平台管理日志"
                 name="admin_manage_log">
      <el-row>
        <el-row class="sj-container">
          <el-table :highlight-current-row="true"
                    :data="table"
                    :show-header="false"
                    border>
            <el-table-column width="150"
                             prop="label">
              <template slot-scope="scope">
                <b>{{scope.row.label}}</b>
              </template>
            </el-table-column>
            <el-table-column min-width="150">
              <template slot-scope="scope">
                <div v-for="(value,index) in detailData[activeName]">
                  <span v-if="index < 10 || isShow">{{value.happened_at}}&nbsp;&nbsp;&nbsp;&nbsp; {{value.adminname}} &nbsp;&nbsp;&nbsp;&nbsp;{{value.action}}</span>
                </div>
                <div class="demo-block-control"
                     v-if="!isShow && detailData[activeName].length > 10"
                     @click="isShow = true">
                  <i class="el-icon-caret-bottom"></i>
                  <span style="display: block;">显示全部</span>
                  <button type="button"
                          class="el-button control-button el-tooltip el-button--text el-button--small"
                          aria-describedby="el-tooltip-7196"
                          tabindex="0"
                          style="display: none;">
                    <span>
                    </span>
                  </button>
                </div>
                <div class="demo-block-control"
                     v-if="isShow"
                     @click="isShow = false">
                  <i class="el-icon-caret-top"></i>
                  <span style="display: block;">收起</span>
                  <button type="button"
                          class="el-button control-button el-tooltip el-button--text el-button--small"
                          aria-describedby="el-tooltip-7196"
                          tabindex="0"
                          style="display: none;">
                    <span>
                    </span>
                  </button>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </el-row>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="标注平台管理日志"
                 name="labeling_manage_log">
      <el-row>
        <el-row class="sj-container">
          <el-table :highlight-current-row="true"
                    :data="table"
                    :show-header="false"
                    border>
            <el-table-column width="150"
                             prop="label">
              <template slot-scope="scope">
                <b>{{scope.row.label}}</b>
              </template>
            </el-table-column>
            <el-table-column min-width="150">
              <template slot-scope="scope">
                <div v-for="(value,index) in detailData[activeName]">
                  <span v-if="index < 10 || isLabelShow">{{value.happened_at}}&nbsp;&nbsp;&nbsp;&nbsp; {{value.adminname}} &nbsp;&nbsp;&nbsp;&nbsp;{{value.action}}
                  </span>
                </div>
                <div class="demo-block-control"
                     v-if="!isLabelShow && detailData[activeName].length > 10"
                     @click="isLabelShow = true">
                  <i class="el-icon-caret-bottom"></i>
                  <span style="display: block;">显示全部</span>
                  <button type="button"
                          class="el-button control-button el-tooltip el-button--text el-button--small"
                          aria-describedby="el-tooltip-7196"
                          tabindex="0"
                          style="display: none;">
                    <span>
                    </span>
                  </button>
                </div>
                <div class="demo-block-control"
                     v-if="isLabelShow"
                     @click="isLabelShow = false">
                  <i class="el-icon-caret-top"></i>
                  <span style="display: block;">收起</span>
                  <button type="button"
                          class="el-button control-button el-tooltip el-button--text el-button--small"
                          aria-describedby="el-tooltip-7196"
                          tabindex="0"
                          style="display: none;">
                    <span>
                    </span>
                  </button>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </el-row>
      </el-row>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      id: this.$route.query.userid || 0,
      isShow: false,
      isLabelShow: false,
      activeName: 'admin_manage_log',
      detailData: {
        labeling_manage_log: [],
        admin_manage_log: [],
      },
      table: [
        {
          key: 'message',
          label: '信息修改记录',
        },
      ],

    }
  },
  computed: {},
  watch: {},
  created () {
    if (this.id) {
      this.setFormData(this.id)
    }
  },
  mounted () { },
  methods: {
    ...Vuex.mapActions([]),

    ifKey (scope, name) {
      return scope.row.key === name
    },
    setFormData (id) {
      request.page('getUserLog', id).then(({data}) => {
        filter.setLoop(this.detailData, data)
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
.demo-block-control {
  text-align: center;
  border: 1px solid rgb(234, 242, 254)
}
</style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersLogDetail.vue